import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BaseSiteService } from '@spartacus/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil, take, filter } from 'rxjs/operators';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { NEW, RELEASED, getNewJourneyUrl, UNRELEASED, getCurrentFlag, MIGRATED } from './constants';

@Component({
    selector: 'app-release-banner',
    templateUrl: './release-banner.component.html',
    styleUrls: ['./release-banner.component.scss'],
    standalone: false
})
export class ReleaseBannerComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private baseSiteId: string = '';
  private currentFlag: string = '';
  private featureFlagSub: Subscription;
  private routerSub: Subscription;
  newJourneyUrl: string = '';
  
  showBanner: boolean = true;

  constructor(
    private baseSiteService: BaseSiteService,
    private readonly cdr: ChangeDetectorRef,
    private featureFlagService: FeatureFlagService,
    private router: Router
  ) {}

  ngOnInit(): void {   
    // Subscribe to flag changes with fallback strategy
    this.featureFlagSub = this.featureFlagService.getFlagObservable(this.currentFlag, UNRELEASED)
      .subscribe(value => {
        this.checkFeatureFlags();
        this.cdr.detectChanges();
      });
    
    // Subscribe to router navigation events to check flags when pathname changes
    this.routerSub = this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        this.checkFeatureFlags();
        this.cdr.detectChanges();
      });
    
    this.baseSiteService.getActive()
      .pipe(takeUntil(this.destroy$))
      .subscribe(baseSiteId => {
        this.baseSiteId = baseSiteId || 'vsh';
        this.checkFeatureFlags();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    
    // Clean up subscriptions
    if (this.featureFlagSub) {
      this.featureFlagSub.unsubscribe();
    }
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
    this.newJourneyUrl = '';
  }

  private checkFeatureFlags(): void {
    // Set default value (feature off) for fallback strategy
    this.currentFlag = getCurrentFlag(window.location.pathname, this.baseSiteId);
    const flagValue = this.featureFlagService.getFlag(this.currentFlag, UNRELEASED);
    
    // Show banner only when feature is in 'new' or 'released' state
    this.showBanner = flagValue === NEW || flagValue === RELEASED || flagValue === MIGRATED;
    this.newJourneyUrl = getNewJourneyUrl(this.currentFlag, this.baseSiteId);
  }
} 
